import { Button, Grid, Typography } from "@mui/material";

import styles from './index.module.css'
import PricingTable from "../../PricingTable";


const TotalContainer = ({otherServices, estimationDetails}) => {
  const currencyCode = (
    estimationDetails?.currency ||
    estimationDetails?.Currency ||
    estimationDetails?.currencyCode ||
    estimationDetails?.CurrencyCode ||
    ''
  )?.toString().toUpperCase();
  return (
    <>
      <Grid container className={`${styles.headerContainer} ${styles.orderTotals}`}>
        <Typography variant="h6">Additional Services</Typography>
        <PricingTable
          priceDetails={otherServices}
          {...(currencyCode ? { currency: currencyCode } : {})}
          isService={true}
          serviceTaxBreakdown={true}
        />
      </Grid>
    </>

  )
}

export default TotalContainer
